import {AxiosResponse} from 'axios';
import {useFormik} from 'formik';
import {useNavigate} from 'react-router-dom';
import {toast} from 'react-toastify';
import Button from '../../../components/button';
import MainFooter from '../../../components/mazraeKit/footers/footerMain';
import CustomHeader from '../../../components/mazraeKit/headers/homeHeader';
import usePostCreateBrand from '../../../services/hookService/postCreateBrand/usePostCreateBrand';
import {brandValidation, initialValuesBrand} from './BrandFormData';
import BrandLogoUpload from './BrandLogoUpload';
import BrandNameInput from './BrandNameInput';

const CreateBrand = () => {
  const navigate = useNavigate();

  const {mutate, isLoading} = usePostCreateBrand();

  const form = useFormik({
    initialValues: initialValuesBrand,
    validationSchema: brandValidation,
    onSubmit: values => {
      const formData = new FormData();

      // Add all fields to FormData

      if (values.name) {
        formData.append('name', values.name);
      }

      if (values.logo) {
        formData.append('logo', values.logo);
      }

      // Submit the FormData
      mutate(formData, {
        onSuccess: (data: AxiosResponse) => {
          // Navigate to Add Product page with the response data
          navigate(`/my-store-brands`, {state: data.data});
        },
        onError: (error: any) => {
          // Showing error of duplicated brand name
          toast.error(
            error?.response?.data.name[0] ||
              'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
          );
        },
      });
    },
  });

  return (
    <div className="flex flex-col h-screen w-full relative">
      <div>
        <CustomHeader
          canScroll={true}
          title="ثبت برند"
          preIcon="icon-nameArrow---Right"
          isActiveRightIcon
          onClick={() => navigate(-1)}
        />
      </div>

      <form
        onSubmit={form.handleSubmit}
        className="p-4 mb-10 w-full overflow-y-auto flex flex-col gap-3"
      >
        {/* <SelectInputGroup form={form} /> */}

        <BrandNameInput form={form} />

        <BrandLogoUpload form={form} />

        <Button
          className="fixed left-4 right-4 bottom-20"
          isLoading={isLoading}
          type="submit"
        >
          ثبت برند
        </Button>
      </form>

      <div className="fixed bottom-0 left-0 right-0">
        <MainFooter />
      </div>
    </div>
  );
};

export default CreateBrand;
